import { post } from '@/utils/request'

/**
 * 通用图片上传
 * @param {File} file - 要上传的图片文件
 * @param {string} url - 上传接口地址，默认 /manage/uploadImage
 * @param {Object} extraData - 额外要上传的表单字段（可选）
 * @returns {Promise<Object>} - 返回后端响应
 */
export function uploadImage(file, url = '/manage/uploadImage', extraData = {}) {
  const formData = new FormData()
  formData.append('file', file)
  // 添加额外字段
  Object.keys(extraData).forEach(key => {
    formData.append(key, extraData[key])
  })
  return post(url, formData)
} 